import script from "./AppPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPopover.vue?vue&type=script&setup=true&lang=js"

import "./AppPopover.vue?vue&type=style&index=0&id=7bf19008&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bf19008"]])

export default __exports__